import { LastContactsComponent } from '../../dialogs/last-contacts/last-contacts.component';
import { Router } from '@angular/router';
import { ContactsService } from '../../store/services/contacts.service';
import { IAccount } from '../../store/models/account.model';
import { AccountService } from 'app/store/services/account.service';
import { openDialog, openSnackbar } from '../../store/actions/page.action';
import { Store } from '@ngrx/store';
import {
  DataSourceParams,
  EFilterSize,
  EFilterType,
  ETableColumnType,
  ITableFIlterGroup,
} from '../../store/models/table.model';
import {
  ELastContacts,
  IActiveContacts,
  ILastContacts,
  ITotalActive,
  IUserContactGroup,
} from '../../store/models/user-group.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApiDataSource } from '../../datasources/api.datasrouce';
import { ITableColumn } from 'app/store/models/table.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IReducers } from 'app/store/reducers';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { EmailStatusComponent } from 'app/accounts/list-accounts/email-status/email-status.component';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { SessionService } from 'app/store/services/session.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { CreateGroupComponent } from 'app/dialogs/create-group/create-group.component';
import { setFlash } from 'app/store/actions/user.action';
import { FLASH_TYPE, IUserSessionData, UserType } from 'app/store/models/user.model';
import { environment } from '../../../environments/environment';
import { CustomColumnComponent } from 'app/shared/ui/custom-column/custom-column.component';
// Contact specific
import { IContactGroup, IContactItem } from 'app/store/models/contact.model';
import { ContactActivityComponent } from 'app/dialogs/contact-activity/contact-activity.component';
import { EInfoSelectItemType } from 'app/store/models/select.model';
import { ButtonSelectComponent } from 'app/shared/ui/button-select/button-select.component';
import { DialogData } from 'app/store/models/dialog.model';
import { updateLeftMenuCount } from '../../store/actions/meeting.action';
import { RContentComponent } from '../../dialogs/quick-response/r-content.component';
import { OneTimeMessageComponent } from '../../dialogs/one-time-message/one-time-message.component';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { SelectionChange } from '@angular/cdk/collections';
import { SendToCampaignComponent } from '../send-to-campaign/send-to-campaign.component';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';
import { TableComponent } from '../../shared/ui/table/table.component';
import {
  EResetOption,
  MANAGE_OPTION_DOWNLOAD,
  MANAGE_OPTION_MERGE,
  MANAGE_OPTION_RENAME,
  MANAGE_OPTION_RESET,
  ManageContactGroupsComponent,
} from '../../dialogs/manage-contact-groups/manage-contact-groups.component';
import * as moment from 'moment';
import {
  ManagerGroupSelectorComponent,
} from '../contacts-listing/manager-group-selector/manager-group-selector.component';
import { MatRadioChange } from '@angular/material/radio';
import { TotalActiveColumnComponent } from './total-active-column/total-active-column.component';
import { EmailPositionComponent } from '../contacts-listing/email-position/email-position.component';
import { SentToCampignDialogComponent } from '../../dialogs/sent-to-campign-dialog/sent-to-campign-dialog.component';
import {
  FailedMovedContactsDialogComponent
} from './failed-moved-contacts-dialog/failed-moved-contacts-dialog.component';

export const CUSTOM_FILTER_TYPE_KEYWORD = 'keyword';
export const CUSTOM_FILTER_TYPE_TAGS = 'tags';

@Component({
  selector: 'app-user-groups-listing',
  templateUrl: './user-groups-listing.component.html',
  styleUrls: ['./user-groups-listing.component.scss'],
})
export class UserGroupsListingComponent implements OnInit, OnDestroy {
  @ViewChild('tableComponent') tableComponent: TableComponent;

  tableReady: boolean;
  searchFilter = '';
  tagsFilter: any;

  selectedTableFilter: 'keyword' | 'tags' = 'keyword';
  tagsFilterAvailble: boolean;


  availableAccounts: IAccount[] = [];

  tableFiltersGroups: ITableFIlterGroup[] = [
    {
      filters: [],
    },
  ];

  tableColumns:
    | ITableColumn<IUserContactGroup>[]
    | ITableColumn<IContactItem>[] = [];
  dataSource: ApiDataSource<IUserContactGroup> | ApiDataSource<IContactItem>;

  tableDataSourceParams: DataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'group_id',
    sortDir: 'desc',
    filters: {},
  };

  totalContacts: number;
  activeContacts: number;

  lastContacts: IActiveContacts;
  cpgns = [];
  sessionData: IUserSessionData;
  iconPaperPlane = faPaperPlane;
  showOneTimeMessage: boolean;
  oneTimeMessageWithContacts: boolean;
  groups: IContactGroup[];
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private popupShown: boolean;
  private selectedRows: IContactItem[] = [];
  oneTimeMessageButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    text: 'Send One-time message',
    size: ButtonSize.SMALL,
    onClick: () =>
      this.store.dispatch(
        openDialog({
          dialogData: {
            content: OneTimeMessageComponent,
            title: 'Send One-Time message',
            canClose: true,
            dialogWidth: '900px',
            componentData: {
              groupIds: this.selectedRows.map(a => a.group_id),
              userSession: this.sessionData,
            },
          },
        }),
      ),
  };
  private exportButtonDisabled: boolean;
  private totalActiveContractsColumnTitle = 'Total/Active';
  private availableTags: {
    size: EFilterSize;
    onFilterChange: (value) => void;
    label: string;
    type: EFilterType;
    items: any[]
  };

  private availableSearch = {
    type: EFilterType.SEARCH,
    size: EFilterSize.HALF,
    items: [
      {
        id: 'search',
        label: ' Enter the Keyword for Search',
        icon: 'search',
      },
    ],
    onFilterChange: value => {
      if(!value) {
        return;
      }
      this.router.navigate(['/user_contacts', 'search'], {
        queryParams: {
          search: value,
        }
      });
      // this.filterChange(value);
    },
  };

  constructor(
    private http: HttpClient,
    private store: Store<IReducers>,
    private accountService: AccountService,
    private contactsService: ContactsService,
    private router: Router,
    private leftMenuService: LeftMenuService,
    private sessionService: SessionService,
  ) {
  }

  showPopup(): void {
    if (this.sessionData.popup_tips) {
      if (this.popupShown) {
        return;
      }

      this.popupShown = true;
      this.store.dispatch(
        openDialog({
          dialogData: {
            content: InfoTipsComponent,
            title: 'Tips',
            canClose: true,
            dialogMinWidth: '700px',
            componentData: {
              type: 'contacts',
            },
          },
        }),
      );
    }
  }

  buildActiveContacts(): void {
    this.contactsService
      .getContactsTotalActive()
      .subscribe((result: ITotalActive) => {
        this.activeContacts = 0;
        this.totalContacts = 0;
        if (result && result.items) {
          if (result.items.active_contacts) {
            this.activeContacts = result.items.active_contacts || 0;
          }

          if (result.items.total_contacts) {
            this.totalContacts = result.items.total_contacts || 0;
            this.totalActiveContractsColumnTitle = `Total/Active/\n (${this.totalContacts}/${this.activeContacts})`;
          }

          if (result.items.contacts_in_campaign) {
            this.totalActiveContractsColumnTitle = `Total/Active/In Campaign\n (${this.totalContacts}/${this.activeContacts}/${result.items.contacts_in_campaign})`;
          }

          this.tableColumns = this.tableColumns.map(c => {
            if (c.id !== 'total_active') {
              return c;
            }

            c.title = this.totalActiveContractsColumnTitle;

            return c;
          });
        }
      });
  }

  buildLastContacts(): void {
    this.contactsService
      .getLastContactsNumbers()
      .subscribe((result: ILastContacts) => {
        if (result && result.items) {
          this.lastContacts = result.items;
        }
      });
  }

  ngOnInit() {
    this.accountService.getTags().subscribe(
      response => {
        this.availableTags = {
          label: 'Tags',
          type: EFilterType.TAGS,
          size: EFilterSize.HALF,
          items: [],
          onFilterChange: value => {
            if(!value) {
              return;
            }
            this.router.navigate(['/user_contacts', 'search'], {
              queryParams: {
                search: value,
                tags: true
              }
            });
            // this.tagChange(value);
          },
        };
        response.items.forEach(item => {
          this.availableTags.items.push({
            id: item.id,
            label: item.name,
            value: item.name,
          });
        });
        this.tagsFilterAvailble = true;
      },
      error => {
      },
      () => {
        if (this.sessionData.user_type === UserType.SINGLE_USER) {
          this.tableFiltersGroups[0].filters.push({
            type: EFilterType.BUTTON,
            label: 'Create new',

            buttonProperties: {
              size: ButtonSize.SMALL,
              color: ButtonColor.ORANGE,
              text: 'Create New',
              onClick: () =>
                this.store.dispatch(
                  openDialog({
                    dialogData: {
                      canClose: true,
                      content: CreateGroupComponent,
                      title: 'Create Empty Group',
                      dialogMinWidth: '700px',
                      onCloseButton: dialogRef => dialogRef.close(),
                      buttons: [
                        {
                          color: ButtonColor.BLUE,
                          text: 'Create',
                          size: ButtonSize.SMALL,
                          onClick: dialog => {
                            if (!dialog.dialogForm.valid) {
                              dialog.dialogForm.markAllAsTouched();
                              return;
                            }
                            this.contactsService
                              .createGroup(
                                dialog.dialogForm.get('group_name').value,
                              )
                              .subscribe(
                                () => {
                                  this.dataSource.refresh();
                                  this.store.dispatch(
                                    setFlash({
                                      data: {
                                        alertMessage:
                                          'Group was created successfully',
                                        type: FLASH_TYPE.ALERT,
                                      },
                                    }),
                                  );
                                },
                                err => {
                                  let msg =
                                    'Something went wrong. Please try again later!';
                                  if (err.error.message !== undefined) {
                                    msg = err.error.message;
                                  }
                                  this.store.dispatch(
                                    setFlash({
                                      data: {
                                        alertMessage: msg,
                                        type: FLASH_TYPE.ALERT,
                                      },
                                    }),
                                  );
                                },
                                () => dialog.closeDialog(),
                              );
                          },
                        },
                      ],
                    },
                  }),
                ),
            },
          });
        }

        this.changeTableFilters(null, !!this.selectedTableFilter);

        if (this.sessionData.export_contact) {
          this.tableFiltersGroups[0].filters.push({
            type: EFilterType.BUTTON,
            label: 'Create new',

            buttonProperties: {
              size: ButtonSize.SMALL,
              color: ButtonColor.BLUE,
              text: 'Export',
              onClick: () => {
                if (this.exportButtonDisabled) {
                  return;
                }
                this.exportButtonDisabled = true;
                this.accountService
                  .exportContacts(this.sessionData.id, 'csv')
                  .subscribe(
                    response => {
                      this.exportButtonDisabled = false;
                      const dataType = response.type;
                      const binaryData = [];
                      binaryData.push(response.body);
                      const downloadLink = document.createElement('a');
                      downloadLink.href = window.URL.createObjectURL(
                        new Blob(binaryData, { type: dataType }),
                      );

                      downloadLink.setAttribute(
                        'download',
                        `contacts_${moment().format('YYYY-MM-DD')}.csv`,
                      );
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                      this.store.dispatch(openSnackbar({
                        snackbarData: {
                          data: {
                            message: 'Contacts are successfully exported. Please check your downloads folder',
                            type: 'success',
                          },
                        },
                      }));
                    },
                    error => {
                      this.exportButtonDisabled = false;
                      error.error.text().then(blobError => {
                        const bError = JSON.parse(blobError);
                        this.store.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                type: 'error',
                                message: bError.message.join('\n'),
                              },
                            },
                          }),
                        );
                      });
                    },
                  );
              },
            },
          });
        }


        if (
          this.sessionData.user_type === UserType.SINGLE_USER
        ) {
          this.tableFiltersGroups[0].filters.push({
            type: EFilterType.BUTTON,
            label: 'Create new',
            hideOnMobile: true,

            buttonProperties: {
              size: ButtonSize.SMALL,
              color: ButtonColor.BLUE,
              text: 'Upload',
              route: ['/user_contacts', 'add_contact'],
            },
          });
        }
      },
    );

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        this.showPopup();
        this.leftMenuService.expand('contacts');
        this.buildActiveContacts();
        this.buildLastContacts();
        this.dataSource = new ApiDataSource<IUserContactGroup>(
          this.http,
          environment.apiUrl + '/v1/contacts/groups',
        );
        this.contactsService.getContactGroups(this.sessionData.id)
          .subscribe(groups => this.groups = groups);

        if (
          this.sessionData.user_type === UserType.PARTNER ||
          this.sessionData.user_type === UserType.MANAGER
        ) {
          this.loadManagerAccounts();
        } else {
          this.prepareCampaigns();
        }
      });
  }

  loadManagerAccounts(): void {
    this.accountService
      .getAccountsBasicInfo(UserType.SINGLE_USER)
      .subscribe(result => {
        this.availableAccounts = result.items;
        this.prepareCampaigns();
      });
  }

  prepareCampaigns(): void {
    this.contactsService.getActiveCampaigns().subscribe(result => {
      if (result && result.items) {
        this.cpgns = result.items.map(item => {
          return {
            id: item.campaign_id,
            value: item.campaign_name,
          };
        });
      }
      this.setTableColumns();
    });
  }

  setTableColumns() {
    this.tableColumns = [
      {
        id: 'group_name',
        title: 'Group Name',
        sortable: true,
        leftAdjusted: true,
        route: row => this.getColumnRoute(row),
        asHtml: true,
        renderer: (element: IUserContactGroup) => {
          return `
                <div class='color__blue__primary'>
                  <span>${element.group_name}</span>
                </div>
              `;
        },
      },
      {
        id: 'total_active',
        title: this.totalActiveContractsColumnTitle,
        hint: 'active_total',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: TotalActiveColumnComponent,
          mapData: {
            total: {
              instance: 'column',
              target: 'total_contacts',
            },
            active: {
              instance: 'column',
              target: 'active_contacts',
            },
            contactsInCampaign: {
              instance: 'column',
              target: 'contacts_in_campaign',
            },
            groupId: {
              instance: 'column',
              target: 'group_id',
            },
            groupName: {
              instance: 'column',
              target: 'group_name',
            },
          },
        },
      },
      {
        id: 'campaign_name',
        title: 'Campaign Name',
        leftAdjusted: true,
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: CustomColumnComponent,
          mapData: {
            row: {
              instance: 'function',
              target: (rowItem: IUserContactGroup) => rowItem,
            },
            items: {
              instance: 'static',
              target: this.cpgns,
            },
            selection: {
              instance: 'function',
              target: rowItem => {
                return selectItem => this.openItemDialog(rowItem, selectItem);
              },
            },
          },
        },
      },
      {
        id: 'content_name',
        title: 'Content Name',
        leftAdjusted: true,
        route: row => this.getColumnRoute(row),
      },
      {
        id: 'status_class',
        title: 'Status',
        type: ETableColumnType.COMPONENT,
        hint: 'status',
        componentProperties: {
          component: EmailStatusComponent,
          mapData: {
            status: {
              instance: 'column',
              target: 'status_class',
            },
          },
        },
      },
    ];

    if (
      this.sessionData &&
      (this.sessionData.user_type === UserType.MANAGER ||
        this.sessionData.user_type === UserType.PARTNER)
    ) {
      this.tableColumns.push({
        id: 'account_id ',
        title: 'Representative',
        type: ETableColumnType.SELECT,
        selectProperties: {
          label: 'Move to',
          confirmMessage: `Warning - you are about to move a contact group from one rep to another, The contact group will be moved to the new reps account and automatically assigned to no campaign, You can use the edit/merge feature to move the contact group to an existing or new campaign, All campaign positions and replay actions will remain intact and all history for the contacts will be moved`,
          onSelection: (value, table, row: IUserContactGroup) => {
            this.contactsService
              .moveContactsToAccount(row.group_id, value)
              .subscribe(response => {

                if (response && response.failed && response.failed.length) {
                  this.store.dispatch(openDialog({
                    dialogData: {
                      title: 'Move contacts status',
                      canClose: true,
                      content: FailedMovedContactsDialogComponent,
                      componentData: {
                        failed: response.failed,
                      }
                    }
                  }));
                }
                const targetAccount = this.availableAccounts.find(
                  a => a.account_id === value,
                );

                if (targetAccount) {
                  this.store.dispatch(
                    openSnackbar({
                      snackbarData: {
                        data: {
                          type: 'success',
                          message: `Contact moved to ${targetAccount.first_name} ${targetAccount.last_name}`,
                        },
                        verticalPosition: 'bottom',
                      },
                    }),
                  );
                }
                table.refresh();
              });
          },
          buildItems: row => {
            return this.availableAccounts.map(account => {
              return {
                label: `${account.first_name} ${account.last_name}`,
                value: account.account_id,
                selected: row.account_id === account.account_id,
              };
            });
          },
        },
      });
    }

    if (this.sessionData.user_type === UserType.SINGLE_USER) {
      this.tableColumns.push({
        id: 'manage',
        title: 'Manage',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          size: ButtonSize.SMALL,
          text: 'Manage',
          color: ButtonColor.BLUE,
          style: 'outline',
          onClick: (row: IUserContactGroup) => this.openManageDialog(row),
        },
      });
      this.tableColumns.push({
        id: 'send-to-campaign',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          size: ButtonSize.SMALL,
          text: 'Send to campaign',
          buttonDisabled: (row: IUserContactGroup) => row.group_name === 'No Campaign',
          color: ButtonColor.BLUE,
          style: 'outline',
          onClick: (row: IUserContactGroup) => this.openSendToCampaignDialog(row),
        },
      });
    }

    if (this.sessionData.user_type === UserType.MASTER) {
      this.tableColumns = [
        ...this.tableColumns,
        {
          id: 'account_email',
          title: 'Account Email',
        },
        {
          id: 'account_id',
          title: 'Account ID',
        },
      ];
    }

    if (this.sessionData.user_type === UserType.SINGLE_USER) {
      this.tableColumns = [
        ...this.tableColumns,
        {
          id: 'delete',
          title: 'Delete',
          type: ETableColumnType.BUTTON,
          buttonProperties: {
            text: 'Delete',
            color: ButtonColor.RED,
            size: ButtonSize.NORMAL,
            buttonDisabled: (row: IUserContactGroup) => row.total_contacts !== 0 || row.group_name === 'No Campaign',
            onClick: (row: IUserContactGroup) => this.store.dispatch(openDialog({
              dialogData: {
                content: `Are you sure you want to delete ${row.group_name} with id ${row.group_id}`,
                title: 'Delete group?',
                canClose: true,
                closeButtonText: 'No',
                buttons: [
                  {
                    text: 'Yes',
                    color: ButtonColor.RED,
                    size: ButtonSize.NORMAL,
                    onClick: (dialog: DialogComponent) => this.contactsService.deleteGroup(row.group_id)
                      .subscribe(
                        () => {
                          this.store.dispatch(openSnackbar({
                            snackbarData: {
                              data: {
                                message: 'Group was successfully deleted',
                                type: 'success',
                              },
                            },
                          }));
                          dialog.closeDialog();
                          this.tableComponent.refresh();
                        },
                        error => this.store.dispatch(openSnackbar({
                          snackbarData: {
                            data: {
                              message: error.error,
                              type: 'error',
                            },
                          },
                        })),
                      ),
                  },
                ],
              },
            })),
          },
        },
      ];
    }

    this.tableReady = true;
  }

  openSendToCampaignDialog(row: IUserContactGroup): void {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `Send ${row.group_name} to campaign`,
          content: SendToCampaignComponent,
          componentData: {
            contactGroup: row,
          },
          canClose: true,
          dialogMinWidth: '600px',
          buttons: [
            {
              color: ButtonColor.BLUE,
              size: ButtonSize.NORMAL,
              text: 'Send',
              onClick: dialog => this.sendGroupToCampaign(row, dialog),
            },
          ],
        },
      }),
    );
  }

  openManageDialog(row: IUserContactGroup): void {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: 'Manage Contact Groups',
          componentData: {
            contactGroup: row,
          },
          content: ManageContactGroupsComponent,
          canClose: true,
          dialogMinWidth: '600px',
          buttons: [
            {
              color: ButtonColor.BLUE,
              size: ButtonSize.NORMAL,
              text: 'Done',
              onClick: dialog => this.manageContactGroup(row, dialog),
            },
          ],
        },
      }),
    );
  }

  sendGroupToCampaign(group: IUserContactGroup, dialog: DialogComponent): void {
    if (!dialog.dialogForm.valid) {
      dialog.dialogForm.markAllAsTouched();
      return;
    }
    if (!dialog.component.componentReady) {
      return;
    }
    const choice = dialog.dialogForm.value.choice;
    let data: any = {};
    if (choice === '0') {
      data = dialog.dialogForm.value;
      delete data.choice;

      if (data.start_date) {
        data.start_date = moment(data.start_date).format('YYYY-MM-DD');
      }
    } else {
      data = {
        campaign_id: null,
      };
    }
    this.contactsService.sendGroupToCampaign(group, data).subscribe(
      result => {
        if (choice === '0') {
          dialog.closeDialog();
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    type: 'success',
                    message:
                      group.group_name +
                      ' was successfully sent to the campaign',
                  },
                },
              }),
            );
            if (this.tableComponent) {
              this.tableComponent.refresh();
            }
        } else {
          dialog.closeDialog();
          this.store.dispatch(openSnackbar({
            snackbarData: {
              data: {
                message: `Group ${group.group_name} was successfully detached`,
                type: 'success',
              },
            },
          }));
          if (this.tableComponent) {
            this.tableComponent.refresh();
          }
        }
      },
      error =>
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                type: 'error',
                message: error.error,
              },
            },
          }),
        ),
    );
  }

  getColumnRoute(column: IUserContactGroup) {
    this.router.navigate(['/user_contacts', column.group_id, 'contacts'], {
      queryParams: {
        group_name: column.group_name,
      },
    });
  }

  onInfoImageClick() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: InfoTipsComponent,
          title: 'Tips',
          canClose: true,
          dialogMinWidth: '700px',
          componentData: {
            type: 'contacts',
          },
          titleIcon: 'Hint Popups Icon',
        },
      }),
    );
  }

  showLastContacts(type: string | ELastContacts, contactsCount: number): void {
    if (contactsCount > 0) {
      this.store.dispatch(
        openDialog({
          dialogData: {
            content: LastContactsComponent,
            title: 'Details',
            canClose: true,
            dialogMinWidth: '700px',
            componentData: {
              type,
            },
          },
        }),
      );
    }
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  openItemDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: 'Notice',
          content: `This group will be available once the action is complete. Please check back later.
        Thank you`,
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: () => this.openItemDialog2(item, data),
            },
          ],
        },
      }),
    );
  }

  openItemDialog2(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: 'Campaign Email',
          content: `You are adding a contact or a group of contacts to an active campaign. Your emails will be validated and Email 1 will be sent during next approved send time.
          Ok to proceed?`,
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: () => this.openItemDialog3(item, data),
            },
            {
              text: 'Cancel',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
            },
          ],
        },
      }),
    );
  }

  openItemDialog3(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: 'Notice',
          content: `This process may take a moment if changes aren't immediately visible please check back in another minute.`,
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: () => this.doUpdate(item, data),
            },
          ],
        },
      }),
    );
  }

  doUpdate(item, data) {
    this.contactsService.updateGroup(item, data).subscribe(response => {
      if (response) {
        this.contactsService.publishCampaign(data).subscribe(() => {
        });
        this.dataSource.refresh();
      }
    });
  }

  filterChange(value) {
    this.searchFilter = value;
    let params = '?';
    if (this.checkFilterAv(this.searchFilter)) {
      params = params + 'search=' + this.searchFilter;
    }
    if (this.checkFilterAv(this.tagsFilter)) {
      if (this.checkFilterAv(this.searchFilter)) {
        params = params + '&';
      }
      params = params + 'tags=' + this.tagsFilter.toString();
    }
    this.tableReady = false;
    this.tableComponent.forceRefresh();

    if (
      !this.checkFilterAv(this.tagsFilter) &&
      !this.checkFilterAv(this.searchFilter)
    ) {
      this.oneTimeMessageWithContacts = false;
      this.dataSource = new ApiDataSource<IUserContactGroup>(
        this.http,
        environment.apiUrl + '/v1/contacts/groups',
      );
      this.prepGroupTable();
    } else {
      this.oneTimeMessageWithContacts = true;
      this.dataSource = new ApiDataSource<IContactItem>(
        this.http,
        environment.apiUrl + '/v1/contacts' + params,
      );
      this.prepContactTable();
      this.tableReady = true;

    }
  }

  tagChange(value) {
    this.tagsFilter = value;
    let params = '?';
    if (this.checkFilterAv(this.searchFilter)) {
      params = params + 'search=' + this.searchFilter;
    }
    if (this.checkFilterAv(this.tagsFilter)) {
      if (this.checkFilterAv(this.searchFilter)) {
        params = params + '&';
      }
      params = params + 'tags=' + this.tagsFilter.toString();
    }

    if (
      !this.checkFilterAv(this.tagsFilter) &&
      !this.checkFilterAv(this.searchFilter)
    ) {
      this.oneTimeMessageWithContacts = false;
      this.tableReady = false;
      this.dataSource = new ApiDataSource<IUserContactGroup>(
        this.http,
        environment.apiUrl + '/v1/contacts/groups',
      );
      this.prepGroupTable();
      this.tableReady = true;
    } else {
      this.oneTimeMessageWithContacts = true;
      this.tableReady = false;
      this.dataSource = new ApiDataSource<IContactItem>(
        this.http,
        environment.apiUrl + '/v1/contacts' + params,
      );
      this.prepContactTable();
      this.tableReady = true;
    }
  }

  checkFilterAv(value) {
    if (
      !value ||
      value === undefined ||
      value === 'udnefined' ||
      value === '' ||
      value.length === 0
    ) {
      return false;
    }
    return true;
  }

  prepGroupTable() {
    this.setTableColumns();
  }

  prepContactTable() {
    this.setContactColumns();
  }

  setContactColumns() {
    let columns: ITableColumn<IContactItem>[] = [
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        renderer: (element: IContactItem) => {
          return `${element.contact_firstname || ''} ${
            element.contact_lastname || ''
          }`;
        },
      },
      {
        id: 'contact_title',
        title: 'Title',
        sortable: true,
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
      },
      {
        id: 'email_position',
        title: 'Position',
        sortable: true,
        type: ETableColumnType.ANCHOR,
        anchorHandler: (column, row) =>
          this.store.dispatch(openDialog({
            dialogData: {
              content: EmailPositionComponent,
              componentData: {
                contactId: row.contact_id,
                userTimezone: this.sessionData.time_zone,
                contactStatus: row.contact_status,
              },
              dialogWidth: '300px',
              title: 'Message dates',
              canClose: true,
              buttons: [{
                text: 'Ok',
                actAsClose: true,
                onClick: dialog => dialog.close(),
                color: ButtonColor.GREEN,
                size: ButtonSize.NORMAL,
              }],
            },
          })),
      },
      {
        id: 'group_name',
        title: 'Group',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ManagerGroupSelectorComponent,
          mapData: {
            data: {
              instance: 'column',
            },
            groups: {
              instance: 'static',
              target: this.groups,
            },
          },
        },
      },
    ];

    if (this.availableAccounts && this.availableAccounts.length > 0) {
      columns.push({
        id: 'account_id',
        title:
          this.sessionData.user_type === UserType.MASTER
            ? 'Account'
            : 'Representative',
        type: ETableColumnType.SELECT,
        selectProperties: {
          label: 'Move to',
          onSelection: (value, table, row: IUserContactGroup) => this.contactsService
            .moveContactToAccount(row.contact_id, value)
            .subscribe(
              () => {
                const targetAccount = this.availableAccounts.find(
                  a => a.account_id === value,
                );
                if (targetAccount) {
                  this.store.dispatch(
                    openSnackbar({
                      snackbarData: {
                        data: {
                          type: 'success',
                          message: `Contact moved to ${targetAccount.first_name} ${targetAccount.last_name}`,
                        },
                        verticalPosition: 'bottom',
                      },
                    }),
                  );
                }
                table.refresh();
              },
              error => {
                if (
                  error &&
                  error instanceof HttpErrorResponse &&
                  error.status === 400 &&
                  error.error
                ) {
                  this.store.dispatch(
                    openSnackbar({
                      snackbarData: {
                        data: {
                          type: 'error',
                          message: error.error,
                        },
                        verticalPosition: 'bottom',
                      },
                    }),
                  );
                }
              },
            ),
          items: this.availableAccounts.map(account => {
            return {
              label: `${account.first_name} ${account.last_name}`,
              value: account.account_id,
            };
          }),
        },
      });
    }

    if (
      this.sessionData.permissions &&
      this.sessionData.permissions.can_find_template
    ) {
      columns.push({
        id: 'response',
        title: 'Reply',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ButtonSelectComponent,
          mapData: {
            buttonProperties: {
              instance: 'static',
              target: {
                text: 'Select',
                size: ButtonSize.SMALL,
                color: ButtonColor.ORANGE,
              },
            },
            selection: {
              instance: 'function',
              target: rowItem => {
                return selectItem =>
                  this.openResponseDialog(rowItem, selectItem);
              },
            },
            items: {
              instance: 'function',
              target: (item: IContactItem) => [
                {
                  label: 'Opportunities',
                  type: EInfoSelectItemType.TYPE_LINK,
                  tag: 'main',
                  dialogContent: this.getDialogData('opportunities'),
                  children: [
                    {
                      label: 'Meetings',
                      tag: 'meeting',
                      type: EInfoSelectItemType.TYPE_LINK,
                      dialogContent: this.getDialogData('meeting'),
                    },
                    {
                      label: 'Order/Quote',
                      tag: 'order',
                      type: EInfoSelectItemType.TYPE_LINK,
                      dialogContent: this.getDialogData('order'),
                    },
                  ],
                },
                {
                  label: 'Cycle',
                  tag: 'cycle',
                  type: EInfoSelectItemType.TYPE_LINK,
                  dialogContent: this.getDialogData('cycle'),
                },
                {
                  label: 'Follow up',
                  tag: 'followup',
                  type: EInfoSelectItemType.TYPE_LINK,
                  dialogContent: this.getDialogData('follow_up'),
                },
                {
                  label: 'Inactive',
                  tag: 'inactive',
                  type: EInfoSelectItemType.TYPE_LINK,
                  dialogContent: this.getDialogData('inactive'),
                },
                {
                  label: 'Remove',
                  tag: 'remove',
                  type: EInfoSelectItemType.TYPE_LINK,
                  dialogContent: this.getDialogData('remove'),
                },
                {
                  label: 'Conversation',
                  tag: 'conversation',
                  type: EInfoSelectItemType.TYPE_LINK,
                  dialogContent: this.getDialogData('conversation'),
                },
                {
                  label: 'Send Email',
                  tag: 'send-email',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  value: 'send_email',
                },
                {
                  label: 'Send to campaign',
                  tag: 'send-to-campaign',
                  type: EInfoSelectItemType.TYPE_NORMAL,
                  value: 'send_to_campaign',
                }
              ],
            },
          },
        },
      });
    }

    columns = [
      ...columns,
      {
        id: 'edit',
        title: 'Edit',
        type: ETableColumnType.BUTTON,
        getButtonProperties: (item: IContactItem) => {
          return {
            color: ButtonColor.ORANGE,
            size: ButtonSize.SMALL,
            text: item.account_id === this.sessionData.id ? 'Edit' : 'View',
          };
        },
        route: (item: IContactItem) => `/user_contacts/${item.contact_id}/edit`,
      },
    ];

    columns = [
      ...columns,
      {
        id: 'activity',
        title: 'Activity',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.GREEN,
          size: ButtonSize.SMALL,
          text: 'Activity',
          onClick: (item: IContactItem) => this.openActivityDialog(item),
        },
      },
    ];
    if (this.sessionData.user_type !== UserType.SINGLE_USER) {
      columns = [
        ...columns,
        {
          id: 'account_firstname',
          title:
            this.sessionData.user_type === UserType.MASTER
              ? 'Account Name'
              : 'Rep-Name',
          dynamicRoute:
            this.sessionData.permissions &&
            this.sessionData.permissions.can_update_account,
          renderer: (element: IContactItem) => {
            return `${element.account_firstname} ${element.account_lastname}`;
          },
          route: (element: IContactItem) => {
            if (
              this.sessionData.permissions &&
              this.sessionData.permissions.can_update_account
            ) {
              return ['/accounts', element.account_id, 'edit'];
            }
          },
        },
      ];
    }
    columns = [
      ...columns,
      {
        id: 'contact_vip',
        title: 'VIP',
        type: ETableColumnType.CHECKBOX,
        sortable: true,
        checkboxProperties: {
          disabled: !this.sessionData.vip_mode,
          label: 'Vip',
          Change: (val: IContactItem) => this.toggleContactVip(val),
        },
      },
      {
        id: 'contact_status',
        title: 'Status',
        route: (element: IContactItem) => {
          if (element.contact_status === 'Inactive') {
          }
        },
      },
    ];

    if (this.sessionData.user_type === UserType.MASTER) {
      columns.push({
        id: 'delete_contact',
        title: 'Delete',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.RED,
          size: ButtonSize.SMALL,
          text: 'Delete',
          onClick: (item: IContactItem) =>
            this.store.dispatch(
              openDialog({
                dialogData: {
                  content: `Contact will be permanently deleted from your list. All associated messages, campaign email records and reply positions will be removed. <br/> Are you sure you want to permanently delete contact ID ${item.contact_id}  with email address ${item.contact_email}?`,
                  title: `Delete contact ${item.contact_email} with ID ${item.contact_id}`,
                  buttons: [
                    {
                      text: 'Yes',
                      size: ButtonSize.NORMAL,
                      color: ButtonColor.RED,
                      onClick: dialog =>
                        this.contactsService
                          .deleteContact(item.contact_id)
                          .subscribe(
                            () => {
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'Contact successfully deleted',
                                      type: 'success',
                                    },
                                  },
                                }),
                              );
                              this.dataSource.refresh();
                              dialog.close();
                            },
                            error =>
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: error.error,
                                      type: 'error',
                                    },
                                  },
                                }),
                              ),
                          ),
                    },
                  ],
                  canClose: true,
                },
              }),
            ),
        },
      });
    }

    this.tableColumns = columns;
  }

  toggleContactVip(val: IContactItem): void {
    this.contactsService
      .setContactVipStatus(val.contact_id, !val.contact_vip)
      .subscribe(res => {
        if (this.tableComponent) {
          this.tableComponent.refresh();
        }
      });
  }

  openActivityDialog(item: IContactItem): void {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `Contact History for ${item.contact_firstname} ${item.contact_lastname}`,
          content: ContactActivityComponent,
          componentData: {
            contactId: item.contact_id,
            contactReplayAction: item.action_name,
          },
          dialogMinWidth: '1200px',
          canClose: true,
        },
      }),
    );
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  onRowsSelection($event: SelectionChange<IContactItem>) {
    this.selectedRows = $event.source.selected;

    this.showOneTimeMessage = !!this.selectedRows.length;
  }

  changeTableFilters($event?: MatRadioChange, forceTo?: boolean) {
    const value = $event?.value || forceTo;
    if (value === CUSTOM_FILTER_TYPE_TAGS) {
      // remove search
      this.tableFiltersGroups[0].filters = this.tableFiltersGroups[0].filters.filter(f => f.type !== EFilterType.SEARCH);
      this.tableFiltersGroups[0].filters.unshift(this.availableTags);
    } else if (value === CUSTOM_FILTER_TYPE_KEYWORD) {
      // remove tags
      this.tableFiltersGroups[0].filters = this.tableFiltersGroups[0].filters.filter(f => f.type !== EFilterType.TAGS);
      this.tableFiltersGroups[0].filters.unshift(this.availableSearch);
    }

    if (!forceTo) {
      this.resetFilters();
    }
  }

  resetFilters = () => {
    this.oneTimeMessageWithContacts = false;
    this.searchFilter = '';
    if (this.tableComponent) {
      this.tableComponent.applyFilter(this.availableSearch, '', 'search');
      this.tableComponent.applyFilter(this.availableTags, '', null, true);
    }
    this.tableDataSourceParams = {
      page: 1,
      pageSize: 10,
      sortDir: 'desc',
      sortAttr: 'id',
      filters: {},
    };
    this.dataSource = new ApiDataSource<IUserContactGroup>(
      this.http,
      environment.apiUrl + '/v1/contacts/groups',
    );
    this.prepGroupTable();
  };

  getRowClass = (row: IUserContactGroup) =>  {
    return row.has_integration ? ['row-integration'] : [];
  }

  getRowHover = (row: IUserContactGroup) => {
    return row.has_integration ? 'This contact group is configured within your Integration' : null;
  }

  private openResponseDialog(rowItem, selectedItem) {
    switch (selectedItem.tag) {
      case 'main':
        break;
      case 'got-it':
        console.log('yay got it ');
        this.contactsService
          .quickResponse({ contact_id: rowItem.contact_id }, 'okgotit')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
            console.log(response);
          });
        break;
      case 'send-mail':
        this.store.dispatch(
          openDialog({
            dialogData: {
              title: selectedItem.label,
              content: RContentComponent,
              componentData: {
                data: selectedItem,
              },
              dialogMinWidth: '1000px',
              canClose: true,
              buttons: [
                {
                  text: 'Ok',
                  actAsClose: true,
                  color: ButtonColor.GREEN,
                  size: ButtonSize.NORMAL,
                },
                {
                  text: 'Close',
                  actAsClose: true,
                  color: ButtonColor.RED,
                  size: ButtonSize.NORMAL,
                },
              ],
            },
          }),
        );
        break;
      case 'send-to-campaign':
        this.store.dispatch(openDialog({
          dialogData: {
            content: SentToCampignDialogComponent,
            dialogMinWidth: '600px',
            canClose: true,
            title: `Sent ${rowItem.contact_firstname || ''} ${rowItem.contact_lastname || ''} to campaign`,
            buttons: [{
              text: 'Send',
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: (dialog) => {
                if(!dialog.component.componentReady) {
                  return false;
                }
                if (!dialog.dialogForm.valid) {
                  dialog.dialogForm.markAllAsTouched();
                  return;
                }

                const campaignId = dialog.dialogForm.value.campaign_id;
                const groupId = dialog.dialogForm.value.group_id;
                const startDate = moment(dialog.dialogForm.value.start_date).format('YYYY-MM-DD');

                this.contactsService.sendContactToCampaign(
                  rowItem.contact_id,
                  campaignId,
                  groupId,
                  startDate,
                ).subscribe(
                  () => {
                    this.store.dispatch(openSnackbar({
                      snackbarData: {
                        data: {
                          message: 'Contact successfully send to campaign!',
                          type: 'success',
                        },
                      },
                    }));
                    dialog.closeDialog();
                    this.tableComponent.refresh();
                  },
                  err => this.store.dispatch(openSnackbar({
                    snackbarData: {
                      data: {
                        message: err.error,
                        type: 'error',
                      },
                    },
                  })),
                );
              },
            }],
          },
        }));
          break;
      default:
        this.openDialog(rowItem, selectedItem);
        break;
    }
  }

  private openDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
            item,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
        },
      }),
    );
  }

  private manageContactGroup(row: IUserContactGroup, dialog: DialogComponent) {
    if (!dialog.dialogForm.valid) {
      dialog.dialogForm.markAllAsTouched();
      return;
    }

    if (dialog.dialogForm.get('option').value === MANAGE_OPTION_RENAME) {
      this.contactsService
        .renameContactGroup(
          row.group_id,
          dialog.dialogForm.get('group_name').value,
        )
        .subscribe(
          result =>
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    type: 'success',
                    message: 'The contact group was successfully renamed',
                  },
                },
              }),
            ),
          error =>
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    type: 'error',
                    message: error.error,
                  },
                },
              }),
            ),
          () => {
            dialog.close();
            this.tableComponent.refresh();
          },
        );
    } else if (dialog.dialogForm.get('option').value === MANAGE_OPTION_RESET) {
      const withReplies =
        +dialog.dialogForm.get('reset_option').value === EResetOption.ALL;

      this.contactsService.resetPosition(row.group_id, withReplies).subscribe(
        result =>
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  type: 'success',
                  message: 'The contact group was successfully reset',
                },
              },
            }),
          ),
        error =>
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  type: 'error',
                  message: error.error,
                },
              },
            }),
          ),
        () => {
          dialog.close();
          this.tableComponent.refresh();
        },
      );
    } else if (dialog.dialogForm.get('option').value === MANAGE_OPTION_MERGE) {
      const groups: IContactGroup[] = dialog.component.contactGroups;
      const targetGroup: IContactGroup = groups.find(
        g => g.group_id === +dialog.dialogForm.get('group_id').value,
      );
      const cases = {
        case_a:
          'The contact group you selected is assigned to the same campaign as the contact group you want to move.  Do you want to merge your groups into one? All contact dispositions and campaign positions will remain unchanged.  You will just consolidate the contact groups. Ok to proceed?',
        case_b:
          'The contact group name you entered already exists and is assigned to a DIFFERENT campaign as the contact group you are editing. Do you want to merge your groups into one? All contact dispositions and campaign positions will remain unchanged. However, your content will change to content associated with the other campaign. Ok to proceed?',
        case_c:
          'The contact group you selected is assigned to No Campaign. You are about to move a group of contacts assigned to an active campaign to a group assigned to No Campaign. The group you are moving will no longer receive any campaign emails. Ok to proceed?',
        case_d:
          'The contact group name you entered already exists and is assigned to a campaign. Do you want to merge your groups into one? You will be sending email 1 to these contacts because they are not currently assigned to a campaign. Ok to proceed?',
        case_e:
          'The contact group name is not assigned to any campaign. Do you want to merge your groups into one? Click Ok to proceed.',
        case_f:
          'You are attempting to merge a contact group that is assigned to a campaign to a contact group that is not assigned to a campaign. After the merge, please assign a campaign to the contact group.',
      };
      let targetCase = 'case_a';

      if (row.campaign_id === targetGroup.campaign_id) {
        targetCase = 'case_a';
      }
      if (row.campaign_id !== targetGroup.campaign_id) {
        targetCase = 'case_b';
      }

      if (targetGroup.group_name === 'No Campaign') {
        targetCase = 'case_c';
      }

      if (!row.campaign_id && targetGroup.campaign_id) {
        targetCase = 'case_d';
      }

      if (!row.campaign_id && !targetGroup.campaign_id) {
        targetCase = 'case_e';
      }

      if (row.campaign_id && !targetGroup.campaign_id) {
        targetCase = 'case_f';
      }

      this.store.dispatch(
        openDialog({
          dialogData: {
            content: cases[targetCase],
            canClose: true,
            title: 'Confirm merge',
            buttons: [
              {
                color: ButtonColor.BLUE,
                text: 'Ok',
                size: ButtonSize.NORMAL,
                onClick: innerDialog => {
                  this.contactsService
                    .mergeGroups(row.group_id, targetGroup.group_id)
                    .subscribe(
                      result => {
                        if (result.success) {
                          this.store.dispatch(
                            openSnackbar({
                              snackbarData: {
                                data: {
                                  type: 'success',
                                  message: result.message,
                                },
                              },
                            }),
                          );
                        }
                      },
                      error =>
                        this.store.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                type: 'error',
                                message: error.error,
                              },
                            },
                          }),
                        ),
                      () => {
                        innerDialog.close();
                        dialog.close();
                        this.tableComponent.refresh();
                      },
                    );
                },
              },
            ],
            onCloseButton: innerDialog => {
              innerDialog.close();
              dialog.close();
            },
          },
        }),
      );
    } else if (
      dialog.dialogForm.get('option').value === MANAGE_OPTION_DOWNLOAD
    ) {
      const format = dialog.dialogForm.get('download_format').value;
      this.contactsService
        .getDownloadGroupContacts(this.sessionData.id, row.group_id, format)
        .subscribe(
          response => {
            const dataType = response.type;
            const binaryData = [];
            binaryData.push(response);
            const downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(
              new Blob(binaryData, { type: dataType }),
            );

            downloadLink.setAttribute('download', `${row.group_name}`);
            document.body.appendChild(downloadLink);
            downloadLink.click();
          },
          error => {
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    type: 'error',
                    message: error.error
                  },
                }})
              );
          },
          () => {
            dialog.close();
          },
        );
    }
  }
}
